export default __webpack_public_path__ + "static/media/fpa50004.72aef109.png";